import type { IconSvgObject } from './types';

const CheckCheckIcon: IconSvgObject = [
  ["path", { d: "M2 13L6 17L16 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 16L12 17L22 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CheckCheckIcon;
